<template>
    <el-container class="not-found-container">
        <!-- <el-header class="header">
            <h2>风铃笔记</h2>
        </el-header> -->
        <el-main class="main-content">
            <img src="@/assets/img/404.svg" alt="404" style="width: 80%;">
            <p>您访问的页面不存在，请返回首页或尝试其他链接。</p>
            <router-link to="/">
                <el-button size="small" type="primary" icon="el-icon-s-home">返回首页</el-button>
            </router-link>
        </el-main>
        <div class="footer-copyright">
            <img alt="风铃笔记" height="20" src="@/assets/img/logo.png">
            <span>
                Copyright © {{ copyRightTime }} &nbsp;<a class="footer-link" href="https://fengling.work">fengling.work
                </a> &nbsp;All Rights Reserved.
            </span>
        </div>
    </el-container>
</template>

<script>
import { getCopyrightTime } from "@/utils/date";
export default {
    name: 'NotFound',
    data() {
        return {
            copyRightTime: getCopyrightTime()
        }
    },
    asyncData() {
        // 可以在这里进行数据预取
        return Promise.resolve()
    },
    metaInfo() {
        return {
            title: '内容未找到 | 风铃笔记',
            meta: [
                {
                    name: 'keywords',
                    content: '风铃笔记, 404, 找不到内容'
                },
                {
                    name: 'description',
                    content: '您访问的页面不存在，请返回首页或尝试其他链接。'
                }
            ]
        }
    },
}
</script>

<style lang="less" scoped>
.footer-copyright {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    height: 40px;
    line-height: 40px;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: center;
    color: #000000;
    font-family: Arial;
    font-size: 12px;
    letter-spacing: 1px;

    .footer-link {
        text-decoration: none;
        color: inherit;

        &:hover {
            color: #444DD1;
        }
    }
}

.not-found-container {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    background: linear-gradient(135deg, #e6f7ff, #f9f0ff);
}

.header h1 {
    color: #ff4d4f;
    font-size: 36px;
    margin-bottom: 20px;
}

.main-content {
    text-align: center;
    font-size: 18px;
    color: #333;
}
</style>